import { useCallback, useState, memo } from "react";
import { Row, Col, Popover } from 'react-bootstrap';
import { BzPopoverOverlay, BzChip, BzButton } from "../components";

const OrderWatchListPopOver = ({ placement, activeOrderType, isOrder, className, arrWatchList, setMarketDepthModal, handleMarketDepthDataSubscription, handleMarketDepthModal, setSingleOrder, children, setIsChartWidget, title, isBzChip, bzChipData, isSubTitle, isSubInfo, subInfo, isBzButton, buttonData, nav, colLeft, colRight, bodyData, footer, sideData, ...props }) => {
    const [showPopover, setShowPopover] = useState(false);


    const handleOnMouseEnter = useCallback(() => {
        setShowPopover(true);
    }, []);

    const handleOnMouseLeave = useCallback(() => {
        setShowPopover(false);
    }, []);

    const DisplayChipData = () => {
        return bzChipData?.map((data, index) => <div key={index} className='chips-wrap'><BzChip className={`chips 
        ${index === 0 ? 'exchange-chip' : 'primary-chip'} font-medium font-size2 text-uppercase me-1 mb-2`}>{data}</BzChip></div>);

    };

    const BzPopover = (
        <Popover className={'scripdetails-popover'}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
        >
            <Popover.Header>
                <div className='p-2'>
                    <Row className='g-0'>
                        <Col md={7} className='flex-column justify-content-start align-items-center'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-medium font-size4 color-text text-truncate me-2'>{title}</div>
                                    <div className='chips-wrap'>
                                        <BzChip className='exchange-chip'>{isBzChip && isSubTitle ? <DisplayChipData /> : null} </BzChip>
                                    </div>
                                </Col>
                            </Row>
                            {(isBzChip && !isSubTitle) ?
                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                       <DisplayChipData />  
                                    </Col>
                                </Row>
                            : null}
                            {isSubInfo ? 
                                <Row className='g-0 mb-1'>
                                    <Col className='d-flex justify-content-start align-items-end'>
                                        <div className='font-medium font-size4 color-text'>{subInfo?.title}</div>
                                        <div className='font-regular font-size2 color-text color-negative ms-1'>{subInfo?.subText}</div> 
                                    </Col>
                                </Row> 
                            : null}
                        </Col>
                        <Col md={5} className='d-flex justify-content-end align-items-start'>                           
                            <Row className='g-0'>
                                <Col className='flex-column text-end align-items-center'>
                                    <div className='font-regular font-size2 color-subtext'>NAV</div> 
                                    <div className='font-medium font-size3 color-text'>&#8377; {props?.data?.nav}</div>                            
                                </Col>
                            </Row>     
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {isBzButton ? buttonData?.map((button, i) => <BzButton key={i} onClick={() => { setSingleOrder(true); }} className={`btn ${button?.class} btn-md text-uppercase ms-1`}>{button?.label}</BzButton>) : null}
                            {nav ?  <>                            
                                                                         
                                    </> 
                            : null}

                            {sideData ? <><div className='font-medium font-size4 color-text'>{sideData?.title}</div>
                                
                            <div className='font-regular font-size2 color-text color-positive ms-1'>{sideData?.subText}</div></> : null}  
                        </Col>
                    </Row>                   
                </div>
            </Popover.Header>
            <Popover.Body className='d-flex flex-column'>
                <div className='bdr-top bdr-btm'>
                    {bodyData?.map((data, i) => <Row key={i} className='g-0 py-2 popover-menu' onClick={() => { return data.action ? data.action(props?.data?.id) : null; }}>
                        <Col className='d-flex align-items-center'>
                            <div className={`icon-16 ${data?.icon} icon-dark`}></div>
                            <div className='font-regular font-size4 color-text ms-2'>{data?.label}</div>
                        </Col>
                    </Row>)}
                </div>
                {footer}
            </Popover.Body>
        </Popover>

    );

    return (
        <div onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <BzPopoverOverlay show={showPopover} placement={placement} popover={BzPopover} delay={{ show: '250', hide: '300' }}>
                {children}
            </BzPopoverOverlay>
        </div>
    );
};

export default memo(OrderWatchListPopOver);